import React, { createContext, useContext, useEffect, useState } from "react";
import RareBoxLogo from "../Logos/RareBoxLogo";
import { GlobalState } from "./GlobalContext";
import { CustomLinearProgress } from "components/ReusableComponents/CustomLinearProgress/CustomLinearProgress";
import { Outlet } from "react-router-dom";

const CustomQueriesContext = createContext();
// api url

const CustomQueriesProvider = ({ children }) => {
	const [filter, setFilter] = useState();
	const [loading, setLoading] = useState(false);
	const { rootPath, setRootPath, setLoginUser } = GlobalState();

	return (
		<CustomQueriesContext.Provider
			value={{
				filter,
				setFilter,
				loading,
				setLoading,
			}}>
			{loading ? (
				<div
					style={{
						width: "200px",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%,-50%)",
					}}>
					<RareBoxLogo />
					<CustomLinearProgress />
				</div>
			) : (
				<Outlet />
			)}
		</CustomQueriesContext.Provider>
	);
};

export const ReportsState = () => {
	return useContext(CustomQueriesContext);
};

export default CustomQueriesProvider;
